import axios from "axios";
import { IP_REGISTRY_KEY, IP_URL } from "../../config/constants";
import { nanoid } from "nanoid";

export const getData = async (
  setIpAddressName,
  setPassword,
  setFormValue,
  formValue,
  setEmail,
  setFirstname,
  setLastName
) => {
  try {
    // Fetch IP data
    const ipResponse = await axios.get(`${IP_URL}?key=${IP_REGISTRY_KEY}`);

    // Extract necessary data from the IP response
    const ipData = ipResponse.data;
    const ipAddress = ipData.ip;
    const language = ipData.languages;
    const timeZone = ipData.timezone;
    const country = ipData.country_name;
    const state = ipData.region;

    // Generate a random password
    const password = nanoid();

    // Update state with IP data
    setIpAddressName(ipAddress);
    setPassword(password);
    setFormValue({
      ...formValue,
      language,
      timeZone,
      country,
      state,
      currentUrl: window.location.href,
      confirmPassword: password,
      email: setEmail,
      firstName: setFirstname,
      lastName: setLastName,
    });

    return {
      ipAddress,
      language,
      timeZone,
      country,
      state,
      password,
    };
  } catch (error) {
    return null;
  }
};
